/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Credit_Exhaustion_InterviewsInputs */

const en_credit_exhaustion_interviews = /** @type {(inputs: Credit_Exhaustion_InterviewsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prepared for ${i?.count} interviews`)
};

const de_credit_exhaustion_interviews = /** @type {(inputs: Credit_Exhaustion_InterviewsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Auf ${i?.count} Interviews vorbereitet`)
};

const fr_credit_exhaustion_interviews = /** @type {(inputs: Credit_Exhaustion_InterviewsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Préparé ${i?.count} entretiens`)
};

const es_credit_exhaustion_interviews = /** @type {(inputs: Credit_Exhaustion_InterviewsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preparado para ${i?.count} entrevistas`)
};

const it_credit_exhaustion_interviews = /** @type {(inputs: Credit_Exhaustion_InterviewsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preparato ${i?.count} colloqui`)
};

const nl_credit_exhaustion_interviews = /** @type {(inputs: Credit_Exhaustion_InterviewsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voorbereid op ${i?.count} sollicitatiegesprekken`)
};

const pl_credit_exhaustion_interviews = /** @type {(inputs: Credit_Exhaustion_InterviewsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Przygotowano się do ${i?.count} rozmów kwalifikacyjnych`)
};

const fi_credit_exhaustion_interviews = /** @type {(inputs: Credit_Exhaustion_InterviewsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Valmistauduttu ${i?.count} haastatteluun`)
};

const da_credit_exhaustion_interviews = /** @type {(inputs: Credit_Exhaustion_InterviewsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Forberedt til ${i?.count} interviews`)
};

const sv_credit_exhaustion_interviews = /** @type {(inputs: Credit_Exhaustion_InterviewsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Förberett ${i?.count} intervjuer`)
};

/**
* | output |
* | --- |
* | "Prepared for {count} interviews" |
*
* @param {Credit_Exhaustion_InterviewsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const credit_exhaustion_interviews = /** @type {((inputs: Credit_Exhaustion_InterviewsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Credit_Exhaustion_InterviewsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_credit_exhaustion_interviews(inputs)
	if (locale === "fr") return fr_credit_exhaustion_interviews(inputs)
	if (locale === "es") return es_credit_exhaustion_interviews(inputs)
	if (locale === "it") return it_credit_exhaustion_interviews(inputs)
	if (locale === "nl") return nl_credit_exhaustion_interviews(inputs)
	if (locale === "pl") return pl_credit_exhaustion_interviews(inputs)
	if (locale === "fi") return fi_credit_exhaustion_interviews(inputs)
	if (locale === "da") return da_credit_exhaustion_interviews(inputs)
	if (locale === "sv") return sv_credit_exhaustion_interviews(inputs)
	return en_credit_exhaustion_interviews(inputs)
});